import { Node } from '@tiptap/vue-2';

export const renderedStylesTag = `rs-tiptap-custom-styles`;

/**
 * Style tag node
 */
export const StyleExtension = Node.create({
  name: 'style',
  group: 'block',
  content: 'text*',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  parseHTML() {
    return [
      {
        tag: 'style',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [ renderedStylesTag, HTMLAttributes, 0 ];
  },
});
